import { render } from "./valid-motion-receipt-alert.vue?vue&type=template&id=34581930"
import script from "./valid-motion-receipt-alert.vue?vue&type=script&lang=js"
export * from "./valid-motion-receipt-alert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__